import React from 'react';
import { Text } from '@shopify/polaris';
import { REFRESH_TARGET_DETAILS } from '../data/refreshTargetDetails';

export default function RefreshTargetDetailLines({ targetKey, darkMode = false }) {
  const lines = REFRESH_TARGET_DETAILS[targetKey];
  if (!lines?.length) return null;

  return (
    <ul
      style={{
        margin: '4px 0 0 0',
        paddingLeft: '18px',
        color: darkMode ? '#a3a3a3' : '#616161',
        fontSize: '12px',
        lineHeight: 1.45
      }}
    >
      {lines.map((line) => (
        <li key={line} style={{ marginBottom: '2px' }}>
          <Text as="span" variant="bodySm" tone="subdued">{line}</Text>
        </li>
      ))}
    </ul>
  );
}
